import React, { useMemo } from 'react'
import draftToHtml from 'draftjs-to-html'
import useReplaceLinkTarget from '../hooks/useReplaceLinkTarget'

const DraftHTML = ({
  content,
  html,
}) => {

  const rootRef = useReplaceLinkTarget({
    html: content,
  })

  const renderHTML = useMemo(() => {
    if(html) return html
    return draftToHtml(content)
  }, [
    html,
    content,
  ])
  
  return (
    <div ref={ rootRef } dangerouslySetInnerHTML={{__html: renderHTML}}></div>
  )
}

export default DraftHTML
